import { Field } from 'formik'
import Translation from '../../Translation/cont/Translation'
import MultiselectCheckboxCinemas from '../../forms/fields/MultiselectCheckboxCinemas'

const PreviewMovieFormFields = ({ values, setFieldValue, cinemas, cliCinemasIdList }) => (
    <>
        <div className="pm-form-group">
            <label className="pm-form-label text-light-uppercase"><Translation id="preview_movies_title_label" /></label>
            <input
                className="input-text-box"
                value={values.title}
                onChange={e => setFieldValue('title', e.target.value)}
                autoFocus
            />
        </div>
        <div className="pm-form-group">
            <label className="pm-form-label text-light-uppercase"><Translation id="preview_movies_expected_startdate_label" /></label>
            <span className="pm-form-info text-small-regular"><Translation id="preview_movies_expected_startdate_info" /></span>
            <input
                className="input-text-box"
                type="date"
                value={values.expectedStartDate}
                onChange={e => setFieldValue('expectedStartDate', e.target.value)}
            />
        </div>
        <div className="pm-form-group">
            <span className="pm-form-info text-small-regular"><Translation id="preview_movies_start_date_description_info" /></span>
            <input
                className="input-text-box"
                value={values.startDateDescription}
                onChange={e => setFieldValue('startDateDescription', e.target.value)}
            />
        </div>
        {cliCinemasIdList.length > 1 && (
            <fieldset className="field-cinemas">
                <legend className="pm-form-label text-light-uppercase"><Translation id="cinemas">Kinos</Translation></legend>
                <div className="select-all-cinemas-button-wrapper">
                    <div className="field-checkbox">
                        <Field
                            key="all"
                            attrid="all"
                            name="cinemas"
                            component={MultiselectCheckboxCinemas}
                            id="alle anwählen"
                            clicinemas="all"
                            value={cliCinemasIdList}
                        />
                    </div>
                </div>
                <div className="grid-container">
                    {cliCinemasIdList.map(cinemaId => {
                        const cinema = cinemas[cinemaId]
                        const { pk, nameShort } = cinema
                        return (
                            <div key={'field' + pk} className="field-checkbox">
                                <Field
                                    key={pk}
                                    attrid={pk}
                                    name="cinemas"
                                    component={MultiselectCheckboxCinemas}
                                    id={nameShort}
                                    clicinemas={cinemas}
                                    value={pk}
                                />
                            </div>
                        )
                    })}
                </div>
            </fieldset>
        )}
    </>
)

export default PreviewMovieFormFields
